// 企业管理模块

//获取所有企业列表
function getAllCompany(pageSize = 10, pageNum = 1, querystr) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "edit", userid: Cookies.get("userid-b"), countNum: pageSize, currpage: pageNum, querystr, pagename: "getentlist" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes) : resolve(false);
          } catch (e) {
            console.log("获取所有企业列表出错");
            resolve(false);
          }
        } else {
          console.log("获取所有企业列表出错");
          resolve(false);
        }
      }
    });
  });
}

//获取企业信息
function getCompanyInformation(entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { entid, pagename: "bgetentinfobyid", action: "edit" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取企业信息出错");
            resolve(false);
          }
        } else {
          console.log("获取企业信息出错");
          resolve(false);
        }
      }
    });
  });
}

//修改发布企业信息
function publishCompany(entid, infor) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), entid, action: "save", processData: false, pagename: "bSaveInnerEntInf", jsonstr: JSON.stringify(infor) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("修改发布企业信息出错");
            resolve(false);
          }
        } else {
          console.log("修改发布企业信息出错");
          resolve(false);
        }
      }
    });
  });
}

//企业名称判重
function iterateName(keyword) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), action: "edit", pagename: "bentselectinner", keyword },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("企业名称判重出错");
            resolve(false);
          }
        } else {
          console.log("企业名称判重出错");
          resolve(false);
        }
      }
    });
  });
}

//企业名称查重
function searchRepetition(keyword) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), action: "edit", pagename: "bentselectinner", keyword },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("企业名称查重出错");
            resolve(false);
          }
        } else {
          console.log("企业名称查重出错");
          resolve(false);
        }
      }
    });
  });
}

//企业二维码
function companyQCode(code) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), action: "edit", pagename: "bgetent2code", code, idxpath: "pages/companyDetail/companyDetail", width: "", strjson: "" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("企业二维码出错");
            resolve(false);
          }
        } else {
          console.log("企业二维码出错");
          resolve(false);
        }
      }
    });
  });
}

//设置企业简称
function setEntShortName(data, id) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "save", pagename: "bSaveEntProInf", userid: Cookies.get("userid-b"), entid: id, jsonstr: JSON.stringify(data) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("设置企业简称出错");
            resolve(false);
          }
        } else {
          console.log("设置企业简称出错");
          resolve(false);
        }
      }
    });
  });
}

//账号设置中，账号判重
function repetitionAccout() {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIEnt,
      data: { type: "e", action: "chkusr", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), chktp: tp, chkval: val },
      dataType: "json",
      success: function (res) {
        const jsonRes = JSON.parse(res);
      }
    });
  });
}

//新建成员判断是否重复
function repalicatePhone(data, id = "", type = "b") {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: id, usertype: type, chkval: data, pagename: "bCheckUserInfo" },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status == "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

export default {
  getAllCompany,
  getCompanyInformation,
  publishCompany,
  iterateName,
  searchRepetition,
  companyQCode,
  setEntShortName,
  repetitionAccout,
  repalicatePhone
};
